require.context('.', false, /\.(png|jpe?g|svg|gif)$/);
require.context('./partners', false, /\.(png|jpe?g|svg|gif)$/);
require.context('./balloons', false, /\.(png|jpe?g|svg|gif)$/);
require.context('./certificates', false, /\.(png|jpe?g|svg|gif)$/);
require.context('./user', false, /\.(png|jpe?g|svg|gif)$/);
require.context('./user/default_avatars', false, /\.(png|jpe?g|svg|gif)$/);
require.context('./mails', false, /\.(png|jpe?g|svg|gif)$/);
require.context('./payment_systems', false, /\.(png|jpe?g|svg|gif)$/);
require.context('./proctored_icons', false, /\.(png|jpe?g|svg|gif)$/);